import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchContactsByTeamAndRankData = args => {
    return doDefaultFetch(
        `/site/api/contacts` +
        `?mapBy=teamId&sort=rank` +
        `&include=team.id` +
        `&include=team.triCode` +
        `&include=team.logos` +
        `&include=team.placeName` +
        `&include=team.commonName` +
        `&include=team.fullName` +
        `&include=team.arenaName` +
        `&include=team.arenaAddress` +
        `&include=team.arenaAddress2` +
        `&include=team.arenaCity` +
        `&include=team.arenaStateProvince` +
        `&include=team.arenaZipPostalCode` +
        `&include=team.arenaCountry` +
        `&include=team.officeAddress` +
        `&include=team.officeAddress2` +
        `&include=team.officeCity` +
        `&include=team.officeStateProvince` +
        `&include=team.officeZipPostalCode` +
        `&include=team.officeCountry` +
        `&exclude=address` +
        `&exclude=city` +
        `&exclude=state` +
        `&exclude=zip` +
        `&exclude=fax`,
        args
    );
};

const fetchCorporateCommsContacts = (args) => {
    return doDefaultFetch('/site/api/contacts/corporateCommunicationsContacts' +
        '?include=team.triCode&sort=rank', args);
}

export default {
    fetchContactsByTeamAndRankData,
    fetchCorporateCommsContacts,
};
